/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2021-01-05
13:12:12 * @modify date 2021-01-05 13:12:12 * @desc [description] */\\
<template>
  <div class="content-wrappper">
    <div class="consultant-container">
      <div class="col-xs-12">
        <router-link class="sub-heading" to="/layout/launchpad">
          <i class="fa fa-angle-left"></i>Add Consultant
        </router-link>
        <div class="row m-0 mt-25" id="manageTeam">
          <div class="col-xs-12">
            <p>Account Name</p>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <div class="col-xs-12 search p-0">
              <input
                class="search-input form-control dropdown-toggle"
                type="text"
                placeholder="Account Name"
                v-model.trim="enteredAccountName"
                @keyup="
                  loadedUser = true;
                  getAccountsListForAccountSearch();
                "
                @focus="
                  loadedUser = true;
                  getAccountsListForAccountSearch();
                "
                @change="validateAccount"
                data-toggle="dropdown"
              />
              <i class="fa fa-search"></i>
              <span
                class="search-reset reset-close-xs"
                v-if="enteredAccountName"
                @click="setAccountFieldValues()"
              >
                <base-icon icon="close_icon" class="icon-close"></base-icon>
              </span>
              <div
                class="col-xs-12 dropdown-menu"
                v-if="enteredAccountName.length > 1 && !loadedUser"
              >
                <ul v-if="accountList.length">
                  <li
                    v-for="(account, index) in accountList"
                    :key="index"
                    @click="setAccountFieldValues(account)"
                  >
                    <span>{{ account.account_name }}</span>
                    <span class="float-rt">{{ account.account_id }}</span>
                  </li>
                </ul>
                <ul class="col-xs-12 p-0" v-else>
                  <li class="bg-smoke-white">No Accounts available.</li>
                </ul>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div class="col-xs-12 p-0" v-if="enteredAccountName && enteredAccountName.length < 2">
                <div class="bg-smoke-red">Please enter at least 2 characters for account name.</div>
              </div>
              <div class="col-xs-12 p-0" v-if="!validAccount">
                <div class="bg-smoke-red">Please select an account.</div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <p>Role</p>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <input type="text" class="form-control" v-model="roleName" readonly />
          </div>
          <div class="col-xs-12">
            <p>First Name</p>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <div class="col-xs-12 search p-0">
              <input
                type="text"
                class="search-input form-control dropdown-toggle"
                placeholder="First Name"
                v-model.trim="consultant.first_name"
                @keyup="
                  loadedUser = true;
                  getusersListForUserSearch(consultant.first_name, 'first_name');
                "
                @focusin="
                  loadedUser = true;
                  getusersListForUserSearch(consultant.first_name, 'first_name');
                "
                maxlength="35"
                data-toggle="dropdown"
              />
              <i class="fa fa-search"></i>
              <!-- <span
                class="search-reset reset-close-xs"
                v-if="enteredUserName"
                @click="setUserFiledvalues()"
              >
                <base-icon icon="close_icon" class="icon-close"></base-icon>
              </span> -->
              <div
                class="col-xs-12 dropdown-menu"
                v-if="consultant.first_name.length > 1 && !loadedUser"
              >
                <div class="list">
                  <template v-if="userList.length">
                    <div
                      v-for="(user, index) in userList"
                      :key="index"
                      @click="setUserFiledvalues(user)"
                      class="list-items d-flex flex-between align-items-center cursor-pointer"
                    >
                      <!-- :class="{
                    selected:
                      consultant.email &&
                      consultant.email === user.email_id,
                  }" -->
                      <div>
                        <div>{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="email">{{ user.email_id }}</div>
                      </div>
                      <img src="/static/images/icons/check.svg" alt="check-icon" />
                    </div>
                  </template>
                  <div class="ft-16 text-emergo-dark-blue text-center" v-else>
                    No Users available.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div
                class="col-xs-12 p-0"
                v-if="consultant.first_name && consultant.first_name.length < 2"
              >
                <div class="bg-smoke-red">Please enter at least 2 characters for first name.</div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <p>Last Name</p>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <div class="col-xs-12 search p-0">
              <input
                type="text"
                class="search-input form-control dropdown-toggle"
                placeholder="Last Name"
                v-model.trim="consultant.last_name"
                @keyup="
                  loadedUser = true;
                  getusersListForUserSearch(consultant.last_name, 'last_name');
                "
                @focusin="
                  loadedUser = true;
                  getusersListForUserSearch(consultant.last_name, 'last_name');
                "
                maxlength="35"
                data-toggle="dropdown"
              />
              <i class="fa fa-search"></i>
              <div
                class="col-xs-12 dropdown-menu"
                v-if="consultant.last_name.length > 1 && !loadedUser"
              >
                <div class="list">
                  <template v-if="userList.length">
                    <div
                      v-for="(user, index) in userList"
                      :key="index"
                      @click="setUserFiledvalues(user)"
                      class="list-items d-flex flex-between align-items-center cursor-pointer"
                    >
                      <!-- :class="{
                    selected:
                      consultant.email &&
                      consultant.email === user.email_id,
                  }" -->
                      <div>
                        <div>{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="email">{{ user.email_id }}</div>
                      </div>
                      <img src="/static/images/icons/check.svg" alt="check-icon" />
                    </div>
                  </template>
                  <div class="ft-16 text-emergo-dark-blue text-center" v-else>
                    No Users available.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0">
              <div
                class="bg-smoke-red"
                v-if="consultant.last_name && consultant.last_name.length < 2"
              >
                Please enter at least 2 characters for last name.
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <p>Email</p>
          </div>
          <div class="col-xs-12 col-sm-8 col-md-6 mb-25">
            <div class="col-xs-12 search p-0">
              <input
                type="text"
                class="search-input form-control dropdown-toggle"
                placeholder="Email"
                v-model="consultant.email"
                @keyup="
                  loadedUser = true;
                  getusersListForUserSearch(consultant.email, 'email');
                "
                maxlength="65"
                data-toggle="dropdown"
              />
              <i class="fa fa-search"></i>
              <div class="col-xs-12 dropdown-menu" v-if="consultant.email.length > 1">
                <div class="list">
                  <template v-if="userList.length">
                    <div
                      v-for="(user, index) in userList"
                      :key="index"
                      @click="setUserFiledvalues(user)"
                      class="list-items d-flex flex-between align-items-center cursor-pointer"
                    >
                      <!-- :class="{
                    selected:
                      consultant.email &&
                      consultant.email === user.email_id,
                  }" -->
                      <div>
                        <div>{{ user.first_name }} {{ user.last_name }}</div>
                        <div class="email">{{ user.email_id }}</div>
                      </div>
                      <img src="/static/images/icons/check.svg" alt="check-icon" />
                    </div>
                  </template>
                  <div class="ft-16 text-emergo-dark-blue text-center" v-else>
                    No Users available.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 p-0 err-container">
              <div class="bg-smoke-red" v-if="consultant.email && consultant.email.length < 2">
                Please enter at least 2 characters for email.
              </div>
              <div
                class="bg-smoke-red errorMsg"
                v-else-if="consultant.email && consultant.email.length > 1 && !validEmail"
              >
                Please enter a valid email address.
              </div>
              <div class="bg-smoke-red errorMsg" v-else-if="emailExists">
                Email already registered with the account.
              </div>
            </div>
          </div>
          <!-- <div class="row button-margin"> -->
          <div
            class="col-xs-offset-1 col-xs-10 col-sm-offset-6 col-sm-5 col-md-offset-6 col-md-5 col-lg-offset-8 col-lg-3"
          >
            <button
              type="button"
              class="btn btn-block emergo-green-button"
              :disabled="disableButtonForAddTeam || loaderStatus"
              @click="addConsultant()"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import Loader from '../UIComponents/Loader.vue';
import { addConsultant, getAccountsList, getUsersList } from '../../apis/submissionBuilder';
import { getListOfRoles } from '../../apis/rbac';
import { emailAlreadyRegistered } from '../../apis/launchPad';

export default {
  data() {
    return {
      consultant: {
        first_name: '',
        last_name: '',
        email: '',
        role_id: 10,
        account_id: ''
      },
      loaderStatus: false,
      placeValue: 'Select Role',
      roleName: '',
      enteredAccountName: '',
      accountList: [],
      userList: [],
      emailExists: false,
      loadedUser: true,
      validEmail: true,
      validAccount: true
    };
  },
  components: {
    Loader
  },
  watch: {
    consultant: {
      deep: true,
      immediate: true,
      handler(currentValue) {
        if (
          currentValue.first_name.length < 2 ||
          currentValue.last_name.length < 2 ||
          currentValue.email.length < 2
        ) {
          this.userList = [];
        }
      }
    },
    enteredAccountName(currentValue) {
      if (currentValue.length < 2) {
        this.accountList = [];
        this.consultant.account_id = null;
      }
    }
  },

  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    // eslint-disable-next-line func-names
    getAccountsListForAccountSearch: debounce(async function () {
      this.validAccount = true;
      if (this.enteredAccountName.length > 1) {
        this.accountList = await getAccountsList(this.enteredAccountName);
        this.loadedUser = false;
      }
    }, 250),

    // eslint-disable-next-line func-names
    getusersListForUserSearch: debounce(async function (item, type) {
      if (item.length > 1) {
        this.userList = await getUsersList({
          filter: { field_name: type, value: item },
          role_id: 10
        });
        this.loadedUser = false;
      }
      if (type === 'email') {
        this.emailExists = false;
        this.validateEmail();
      }
    }, 250),
    async setAccountFieldValues(account = '') {
      this.validAccount = true;
      this.consultant.account_id = account.account_id || null;
      this.enteredAccountName = account.account_name || '';
      this.validateAccount();
      if (this.consultant.account_id && this.consultant.email) await this.checkAccountEmail();
      this.$forceUpdate();
      this.accountList = [];
    },
    async setUserFiledvalues(user = '') {
      this.consultant.first_name = user.first_name || '';
      this.consultant.email = user.email_id || '';
      this.consultant.last_name = user.last_name || '';
      this.validateEmail();
      if (this.consultant.account_id && this.consultant.email) await this.checkAccountEmail();
      this.$forceUpdate();
      this.userList = [];
    },
    async checkAccountEmail() {
      this.emailExists = await emailAlreadyRegistered(
        this.consultant.account_id,
        this.consultant.email
      );
    },
    async validateEmail() {
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; // eslint-disable-line
      if (mailformat.test(this.consultant.email)) {
        if (this.consultant.account_id && this.consultant.email) {
          await this.checkAccountEmail();
        }
        this.validEmail = true;
        return true;
      }
      this.validEmail = false;
      return false;
    },
    validateAccount() {
      this.validAccount = this.enteredAccountName.length > 2 && this.consultant.account_id;
    },
    async getRoles() {
      this.loaderStatus = true;
      this.roleName =
        (await getListOfRoles()).find((role) => role.role_id === this.consultant.role_id)
          ?.role_name || ''; // eslint-disable-line
      this.loaderStatus = false;
    },
    async addConsultant() {
      this.loaderStatus = true;
      this.consultant.account_id = parseInt(this.consultant.account_id, 10);
      const response = await addConsultant(this.consultant);
      this.loaderStatus = false;
      if (response && response.status === 'Success') {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: response.message,
          group: 'custom-notification'
        });
        this.consultant = {
          first_name: '',
          last_name: '',
          email: '',
          role_id: 10,
          account_id: ''
        };
        this.enteredAccountName = '';
      } else if (response && response.status === 'Failed') {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: response.message,
          group: 'custom-notification'
        });
      }
    }
  },
  computed: {
    disableButtonForAddTeam() {
      if (
        this.consultant.first_name &&
        this.consultant.last_name &&
        this.consultant.email &&
        this.validateEmail() &&
        this.consultant.role_id &&
        this.consultant.account_id &&
        !this.emailExists
      ) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getRoles();
  }
};
</script>
<style scoped lang="scss">
.bg-smoke-red {
  color: $deep-thick-danger;
}
.consultant-container {
  padding: 25px 20px;
}
.ml-15 {
  margin-left: 15px;
}
ul {
  padding-left: 0;
  margin: 0;
  max-height: 230px;
  overflow: auto;
  overflow-x: hidden;
  li {
    list-style-type: none;
    padding: 8px;
    cursor: pointer;
    position: relative;
    &:not(:last-child):after {
      border-bottom: 0.5px solid #bdbdbd;
      content: '';
      position: absolute;
      bottom: 0px;
      left: 10px;
      right: 10px;
    }
    &:hover {
      font-weight: 500;
      color: $primary;
    }
  }
}
.search {
  .search-input {
    padding-left: 35px;
    width: 100%;
  }
  position: relative;
  float: left;
  > i.fa-search {
    position: absolute;
    top: 9px;
    left: 15px;
  }
  span.search-reset {
    top: 5px;
    right: 10px;
    font-size: 17px;
  }
}

.float-rt {
  float: right;
}
.list-items {
  padding: 8px 16px;
  color: $primary;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  .email {
    font-size: 14px;
    color: $deep-gray;
  }
  &:hover {
    background: $mystic-gray-alpha;
  }
  img {
    display: none;
  }
  &.selected {
    font-weight: 700;
    color: $primary;
    img {
      display: block;
    }
  }
}
.icon-close {
  color: $deep-gray !important;
  float: right;
  cursor: pointer;
}
.sub-heading {
  > i {
    margin-right: 6px;
  }
  font-family: $font-family-roboto;
  font-style: normal;
  font-size: 18px;
  color: $primary;
  cursor: pointer;
}
.mt-25 {
  margin-top: 25px;
}
.mb-25 {
  margin-bottom: 25px;
}
.button-margin {
  margin-top: 35px;
}
.open + .err-container .errorMsg {
  display: none;
}
.dropdown-menu {
  margin-top: 10px;
  .list {
    max-height: 230px;
    overflow: auto;
    overflow-x: hidden;
  }
  &::before {
    border-bottom: 10px solid rgba(0, 0, 0, 0.2);
    border-left: 10px solid rgba(0, 0, 0, 0);
    border-right: 10px solid rgba(0, 0, 0, 0);
    content: '';
    display: inline-block;
    right: 10%; /* position */
    position: absolute;
    top: -11px;
  }
  &::after {
    border-bottom: 10px solid #ffffff;
    border-left: 10px solid rgba(0, 0, 0, 0);
    border-right: 10px solid rgba(0, 0, 0, 0);
    content: '';
    display: inline-block;
    right: 10%; /* position */
    position: absolute;
    top: -9px;
  }
}
</style>
